import { registerDecorator, ValidationArguments, ValidationOptions } from 'class-validator';

/**
 * Checks if contains "linkedin."*"/company/"*
 */
export function IsLinkedinCompanyUrl(validationOptions?: ValidationOptions) {
    return function (object: Object, propertyName: string) {
        registerDecorator({
            name: 'isLinkedinCompanyUrl',
            target: object.constructor,
            propertyName: propertyName,
            options: validationOptions,
            validator: {
                validate(value: string, args: ValidationArguments) {
                    if (typeof value != 'string') return false;
                    if (!value.match(/linkedin\..*\/company\/.+/)) return false;

                    return true;
                },
            },
        });
    };
}
